const shoppingCartDictPT = {
  productType: "Tipo do produto:",
  soldBy: "Vendido por",
  pickUpInStore: "Retirar na loja",
  orderResume: "Resumo do Pedido",
  shippingOptions: "Opções de envio",
  checkCatalog: "Aproveitar ofertas",
  emptyCartText: "Seu carrinho de compras está vazio.",
  emptyCartSuggestion:
    "Acesse a nossa loja e veja todas as vantagens de que a Extraconomy pode oferecer.",
  percentualCreditInfo: "Informações de crédito percentual",
  shop: "Loja",
  searchProducts: "Buscar produtos...",
  searchByTitleInThisSubcategory: "Pesquise nessa subcategoria...",
  byCap: "Por",
  product: "Produto",
  noResultsFound: "Nenhum resultado encontrado.",
  shoppingCart: "Carrinho de compras",
  cart: "Carrinho",
  subtotal: "Subtotal",
  onlyOneSeller: "Você só pode comprar produtos de um vendedor.",
  items: "itens",
  platformFee: "Taxa da plataforma",
  total: "Total",
  walletBalance: "Saldo na carteira",
  amountToPayWithWalletBalance: "Pague com o saldo da sua carteira",
  amountToPayWithExtracredit: "Pague com Extracredit",
  sendYourTransferReceipt: "Envie o comprovante da transferência aqui",
  youWillNeedToTransfer: "Você deve transferir",
  toTheBankAccount: "para a conta bancária",
  andUploadTheReceipt: "e fazer o upload do comprovante",
  finishOrder: "Fechar pedido",
  finish: "Finalizar",
  goToPayment: "Ir para pagamento",
  searching: "Pesquisando",
  inSubcategory: "na subcategoria",
  inAllProducts: "em todos os produtos",
  productMaximumExtracoinPercent: "Porcentagem máxima de Extracredit (Produto)",
  userMaximumExtracoinPercent: "Porcentagem máxima de Extracredit (Usuário)",
  checkout: "Checkout",
  amountToPayAtCheckout: "Valor a pagar no checkout",
  orderData: "Dados do pedido",
  howWillPay: "Como vai pagar",
  otherMethods: "Outras formas",
  creditRequested: "Crédito solicitado",
  moreDetails: "mais detalhes",
  productNotFound: "Produto não encontrado. Tente pesquisar em nosso catálogo.",
  downloadableAndNonDownloadable:
    "Produtos baixáveis e não-baixáveis não podem estar no mesmo carrinho.",
  balanceAvailable: "Saldo Extracredit",
  freeExtracoinExplanation1: "Como um",
  freeExtracoinExplanation2:
    "recém-registrado, você receberá um pagamento completo de Extracredit gratuitamente em seus três primeiros pedidos, o que significa que você pagará o valor mínimo da compra sem gastar seus créditos Extracredit.",
  itemFavorited: "Item adicionado aos favoritos.",
  itemRemovedFromFavorites: "Item removido dos favoritos.",
  info: "Info",
  searchForShipping: "Pesquisar opções de envio para este endereço de correspondência",
  shippingQuotesFor: "Cotações de envio para",
  pleasePickASendMethod:
    'Clique no botão "Opções de envio para este endereço de correspondência" e depois selecione um método de envio',
  shippingCost: "Frete",
  searchAddress: "Auto preencher com CEP",
  shippingResponsibilitySeller: "O envio é de responsabilidade do vendedor",
  plataformFeeExplanation: "A taxa da plataforma é de 5% do valor total dos produtos.",
  cashbackExplanation:
    "Qualquer valor que não for pago em extracredit terá 50% dele convertido em cashback, retornando para a sua carteira em extracredit.",
  thankYouForYourPurchase: "Obrigado por sua compra",
  pleaseFillAllFieldsAddressOrSearchShippingMethod:
    "Por favor, preencha todos os campos do endereço ou clique em opções de envio.",
  deliveryAddress: "Endereço de entrega",
  pickUpAddress: "Retirar seu pedido em",
  orderId: "ID do pedido",
  orderDate: "Data do pedido",
  orderTotal: "Total do pedido",
  extraconomyExplain:
    "Você tem a flexibilidade de utilizar seu saldo Extracredit e/ou o saldo da carteira para pagar seu pedido. Escolha abaixo quanto deseja usar de cada um para completar sua compra.",
  orderInformation: "Informações do pedido",
  goToMyShoppings: "Ir para minhas compras",
  errorDontHavePhoneNumber:
    "Você não tem um número de telefone cadastrado. Preencha seu número de telefone e Código de Telefone do País para continuar.",
  insufficientFunds: "saldo insuficiente",
  errorCheckout:
    "Houve um erro ao finalizar seu pedido. Por favor, entre em contato com o suporte pelo whatsapp a seguir. E não se esqueça de informar as informações abaixo para ele.",
  contactEmail: "Entrar em contato",
  yourOrderWillBeProcessed: "Seu pedido será liberado após a confirmação da transferência.",
  weWillNotifyYou: "Notificaremos você por e-mail após a confirmação.",
  creditCardInfo: "Informe os dados do seu cartão de crédito",
  error: "Erro",
  invalidCardDetails: "Preencha corretamente os dados do seu cartão de crédito",
  confirmation: "Confirmação",
  youDontHaveAddress: "Você ainda não tem um endereço cadastrado",
  paymentFinished: "Pagamento realizado com sucesso!",
  yourOrderWillBeReady: "Seu pedido será confirmado assim que recebermos seu pagamento.",
  paymentDone: "Pagamento efetuado",
  orderDetailsCart: "Detalhes do pedido",
  someItensMightBeDeliveredSeparately: "Alguns itens poderão ser entregues separadamente.",
  invoiceAddress: "Endereço da fatura",
  shipToMyAddress: "Enviar para o meu endereço",
  paypalPayment: "Pagamento com paypal ou diretamente na sua carteira",
  myCredits: "Meus créditos",
  itemsRemoved: "Item removido do carrinho",
  combinePaymentMethods: "Combinar 2 ou mais formas de pagamento",
  combinePaymentExplanation: "Você poderá combinar mais de um método de pagamento para realizar sua compra.",
  selectPaymentMethod: "Selecione o método de pagamento",
  paymentTermsAcceptance: "Ao clicar em Pagar, você aceita nossas condições gerais de uso e as condições gerais de venda de nossos comerciantes.",
  payWithExtracreditAndWallet: "Pague com extracrédito e saldo da carteira",
  payWithBankTransfer: "Pague com transferência bancária",
  payWithCreditCard: "Pague com cartão de crédito",
  payWithPayPal: "Pague sua compra com PayPal",
  continueShopping: "Continuar comprando",
  afterTransferUploadReceipt: "Após realizar a transferência você deverá fazer o upload do comprovante abaixo.",
  uploadReceipt: "Carregar comprovante",
  receiptUploadedSuccessfully: "Comprovante enviado com sucesso!",
  removeReceipt: "Remover comprovante",
  bankTransferImportantNote: "Importante: pagamentos por transferência bancária não são processados automaticamente. Nossa equipe fará a verificação para garantir a segurança da transação.",
  paymentWithExtracredit: "Pagamento com Extracrédito",
  toBeUsed: "para ser utilizado",
  paymentWithWallet: "Pagamento com Saldo da Carteira",
  paymentCombination: "Combinação de Pagamentos",
  paymentCombinationExplanation: "Você pode combinar os valores de extracrédito e saldo da carteira para completar seu pagamento. O valor total deve ser igual ao valor da compra.",
  paymentCompleteWithOtherMethods: "Pagamento completo com outros métodos",
  paymentCompleteWithOtherMethodsExplanation: "O valor total já foi coberto pelos outros métodos de pagamento selecionados.",
  totalAlreadyCovered: "Valor total já coberto",
  methodNotAvailable: "Método não disponível",
  methodNotAvailableExplanation: "Este método de pagamento não está disponível no momento.",
  noWalletBalanceAvailable: "Você não possui saldo na carteira disponível",
  walletBalanceRequired: "Para usar esta forma de pagamento, você precisa ter saldo em sua carteira.",
  insufficientWalletBalance: "Saldo insuficiente",
  insufficientWalletBalanceMessage: "Seu saldo de {currency} {amount} não é suficiente para pagar o valor total de {currency} {total}. Escolha outra forma de pagamento ou ative o modo de combinar pagamentos.",
  noExtracreditAvailable: "Você não possui extracredit disponível",
  extracreditRequired: "Para usar esta forma de pagamento, você precisa ter saldo em seu extracredit.",
  insufficientExtracredit: "Saldo insuficiente",
  insufficientExtracreditMessage: "Seu saldo de {currency} {amount} não é suficiente para pagar o valor total de {currency} {total}. Escolha outra forma de pagamento ou ative o modo de combinar pagamentos.",
  extracreditAmountDescription: "Digite um valor que será usado do seu saldo extracrédito.",
  walletAmountDescription: "Digite um valor que será usado do saldo da sua carteira.",
  modify: "Modificar",
  freight: "Frete",
  free: "Grátis",
  lookingTheBestShippingMethod: "Estamos buscando a melhor forma de envio",
  processingPayment: "Processando pagamento...",
  userInfoDialogTitle: "Informações do usuário",
  userInfoDialogDescription: "Para continuar com o checkout, precisamos que você preencha algumas informações obrigatórias.",
  requiredUserInfo: "Dados de faturamento",
  fillRequiredUserInfo: "Preencher informações obrigatórias",
  fillRequiredUserInfoDescription: "Você precisa preencher algumas informações obrigatórias para continuar com o checkout (nome completo, telefone e documento de identificação).",
  firstName: "Nome",
  lastName: "Sobrenome",
  surname: "Sobrenome",
  phone: "Telefone",
  invalidPhoneNumber: "Número de telefone inválido",
  documentType: "Tipo de documento",
  enterYourFirstName: "Digite seu nome",
  enterYourLastName: "Digite seu sobrenome",
};

export default shoppingCartDictPT;
